export default function DifferenceSection() {
  return (
    <section id="difference" data-testid="difference-section" className="py-24 md:py-32 bg-navy-dark">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="mb-16 animate-on-scroll">
          <p className="text-sm tracking-[0.3em] uppercase text-gold font-body font-medium mb-4">
            About LexSant
          </p>
          <h2 className="font-heading text-4xl md:text-5xl lg:text-6xl tracking-tight text-white leading-tight">
            About LexSant Legal & Advisory LLP
          </h2>
          <div className="h-px w-16 bg-gold/40 mt-6" />
        </div>

        <div className="grid md:grid-cols-2 gap-16 lg:gap-24">
          {/* Left */}
          <div className="animate-on-scroll space-y-6">
            <p className="text-base md:text-lg text-gray-400 font-body leading-relaxed">
              LexSant Legal & Advisory LLP is a New Delhi-based law firm focused on complex disputes, strategic advisory, taxation, intellectual property, sports law, and regulatory matters.
            </p>
            <p className="text-base md:text-lg text-gray-400 font-body leading-relaxed">
              Founded by lawyers with backgrounds spanning government litigation, constitutional law, white-collar defence, taxation, and sports governance, the firm combines courtroom advocacy with commercially driven legal solutions.
            </p>
          </div>

          {/* Right */}
          <div className="animate-on-scroll space-y-6">
            <div className="border-l-2 border-gold pl-8 space-y-6">
              <p className="text-base md:text-lg text-gray-400 font-body leading-relaxed">
                The firm advises and represents individuals, family offices, entrepreneurs, corporations, financial institutions, athletes, sports organizations, educational institutions, and public bodies before courts, tribunals, arbitral forums, and regulatory authorities across India.
              </p>
              <p className="text-base md:text-lg text-gray-400 font-body leading-relaxed">
                LexSant's approach is built upon strategic thinking, rigorous legal analysis, and practical commercial understanding, enabling clients to navigate complex legal challenges with confidence.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
